import RestService from '../services/rest';

async function getDataGrid(tableParams) {
  return RestService.postAuthenticated('outboundPendingAllocationMonitor/list', tableParams);
}

async function getDataGridIds(tableParams) {
  return RestService.postAuthenticated('outboundPendingAllocationMonitor/list/ids', tableParams);
}

async function allocateProducts(outboundOrderId, outboundProductId, isSimulation) {
  return RestService.postAuthenticated('outboundOrders/allocateProducts', {
    outboundOrderId, outboundProductId, isSimulation,
  });
}

async function allocateBulkProducts(outboundProductIds) {
  return RestService.postAuthenticated('outboundOrders/allocateBulkProducts', {
    outboundProductIds,
  });
}

export default {
  getDataGrid,
  getDataGridIds,
  allocateProducts,
  allocateBulkProducts,
};
